<template>
  <article>
    <h1 class="text-h3">Virtual Well</h1>
    <p>Virtual Well uses sophisticated machine learning models to help generate probable reserve estimates of new wells depending on user supplied location and characteristics.</p>
    <v-card flat outlined color="grey"><v-img eager contain src="@/assets/images/virtual.png"></v-img></v-card>
  </article>
</template>
<script>
export default {
  name: "HelpVirtual"
}
</script>